import { YAxisHorizontalWrapFactor } from 'helpers/labels/wrapLabels';
import { toPrecision } from './commons';

/**
 * Return the min value of the given axis from a list of echarts series, with an extra margin.
 * The margin is proportional to the min-max range of the serie.
 * We need this because echarts cannot properly display several bar chart series
 * with auto axis rescaling: see https://github.com/apache/echarts/issues/15189
 */
export const getMinValue = (min: number, max: number) => {
    const margin = 0.2 * (max - min);
    const minValue = toPrecision(min - margin, 2);

    // if the min value with the margin is < 0 and we have not negative value, we set the minimum to 0
    if (minValue < 0 && min >= 0) {
        return 0;
    }
    return minValue;
};

export const getAxisLabelWidthFactor = (
    verticalAxisWidth: 'sm' | 'md' | 'lg' | undefined,
) => {
    switch (verticalAxisWidth) {
        case 'sm':
            return YAxisHorizontalWrapFactor;
        case 'md':
            return YAxisHorizontalWrapFactor * (2 / 3);
        case 'lg':
            return YAxisHorizontalWrapFactor * 0.5;
        default:
            return YAxisHorizontalWrapFactor;
    }
};
